export default function AssignGroupsHeader() {
  // HeaderVariantMap requires to provide at least an empty element to display
  // other parts of header (bulk actions, etc.)
  return <div />;
}
